/*
 * Copyright (c) 2022. Nedaware SL
 */

/**
 * Nedaware S.L.
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */

import {ComponentPortal, ComponentType, Portal} from "@angular/cdk/portal";

export interface WidgetType extends ComponentType<Widget> {
    minCols: number;
    minRows: number;
    maxCols?: number;
    maxRows?: number;
    widgetName: string;
    widgetKey: string;
    link?: string;
}

export interface Widget {
}

export class PlacedWidget {
    private readonly _portal: Portal<any>;
    private _row: number;
    private readonly _rows: number;
    private _column: number;
    private readonly _cols: number;
    private readonly _component: WidgetType;
    public id: any;
    private _link?: string = null;

    constructor(widget: WidgetType, row: number, column: number, rows: number, cols: number, link?: string, id?: any) {
        this._component = widget;
        this._portal = new ComponentPortal(widget);
        this._row = row;
        this._rows = rows;
        this._cols = cols;
        this._column = column;
        this._link = link;
        if (id) {
            this.id = id;
        }
    }

    get component(): WidgetType {
        return this._component;
    }

    get portal(): Portal<any> {
        return this._portal;
    }

    get row(): number {
        return this._row;
    }

    get rowRange(): [number, number] {
        return [this._row, this._row + this._rows - 1];
    }

    get column(): number {
        return this._column;
    }

    get colRange(): [number, number] {
        return [this._column, this._column + this._cols - 1];
    }

    set row(value: number) {
        this._row = value;
    }

    set column(value: number) {
        this._column = value;
    }

    get rows(): number {
        return this._rows;
    }

    get cols(): number {
        return this._cols;
    }

    get link(): string {
        return this._link;
    }

    set link(value: string) {
        this._link = value;
    }
}
